import { clearClientSessionWithRedirect } from '@flex-services-platform/auth';
import { decideError, HttpErrorType } from '@flexteam/error';

function handleApiError(error) {
  const [errorType, httpError] = decideError(error);
  let isHandled = false;
  switch (errorType) {
    case HttpErrorType.Unauthorized: {
      clearClientSessionWithRedirect(
        window.location.href.replace(window.location.origin, "")
      );
      isHandled = true;
      break;
    }
    case HttpErrorType.IpBlockedAllFeature: {
      const ipBlockPath = "/auth/ip-blocked";
      if (!window.location.href.includes(ipBlockPath)) {
        window.location.reload();
      }
      isHandled = true;
      break;
    }
  }
  return { isHandled, errorType, httpError };
}

export { handleApiError };
//# sourceMappingURL=handleApiError.mjs.map
